<upp-visible-control mode="content" *ngIf="discount">
    <ion-item>
        <div class="thumb-box" slot="start" uppDataid="disocuntthumb-image-info">
            <div class="image-box">
                <upp-image [src]="discount.photo || discount.avatar"></upp-image>
            </div>
        </div>    
        <ion-label>
            {{tr(discount.name) || tr('@ticket_offer_noname')}}<br/>
            <ng-container *ngIf="discount.description !== null">
                <span class="small">{{tr(discount.description)}}</span>
            </ng-container>
            <ng-container *ngIf="discount.description === null">
                <span class="small" *ngIf="discount.type === 'TICKETFIXED'">{{tr('@place_discount_fixed_applied')}}</span>
                <span class="small" *ngIf="discount.type === 'TICKETPRCNT'">{{tr('@place_discount_prcnt_applied', [ discount.value ])}}</span>
            </ng-container>
        </ion-label>
        <ng-container *ngIf="chargeinfo">
            <ion-label color="medium" class="price" style="font-size: 30px;" slot="end">
                {{chargeinfo.int}}<span class="decimal">,{{chargeinfo.dec}}</span>{{tr('@currency')}}
            </ion-label>    
        </ng-container>        
    </ion-item>
</upp-visible-control>
